module.exports = __webpack_public_path__ + "img/pball.38b15a35.svg";